﻿let $ = require('jquery');
let SizerBreakpoint = require('../../SizerBreakpoint');

$('.jnf-widget.jnf-widget-menu-1').each(function (menuIndex, menuElement) {
	let $menuElement = $(menuElement);

	let onOpenClick = function () {
		$menuElement.trigger('mobileMenuOpen');
	};

	new SizerBreakpoint({
		element: $menuElement
	});

	$menuElement.on('click', '.jnf-widget-menu-1-mobile-menu-open', onOpenClick);
});